import sanitizeHtml from 'sanitize-html';

export const stripHtmlTags = function (html: string | null | undefined): string {
  if (!html) {
    return "";
  }

  return sanitizeHtml(html, {
    allowedTags: [],
    allowedAttributes: {},
  });
}
